(function () {
  function initNav(nav) {
    var toggle = nav.querySelector('[data-cmh-nav-toggle]');
    var panel = nav.querySelector('[data-cmh-nav-panel]');
    if (!toggle || !panel) return;

    function setOpen(open) {
      nav.dataset.open = open ? 'true' : 'false';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close primary navigation' : 'Open primary navigation');
    }

    toggle.addEventListener('click', function () {
      setOpen(nav.dataset.open !== 'true');
    });

    panel.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });

    setOpen(false);
  }

  function initReveal() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!nodes.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }

    document.body.classList.add('cmh-motion-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (node, index) {
      node.style.transitionDelay = Math.min(index % 4, 3) * 70 + 'ms';
      observer.observe(node);
    });
  }

  var analyticsProcessingAllowed = false;
  var marketingProcessingAllowed = false;
  var trafficStorageKey = 'cmh_traffic_source';
  var organicSources = ['google', 'bing', 'yahoo', 'duckduckgo'];
  var allowedLinkPositions = [
    'primary_nav',
    'home_hero',
    'care_path',
    'portal',
    'emotional_cta',
    'final_cta',
    'faq_cta',
    'quiz_cta',
    'article_body'
  ];

  function clearTrafficSource() {
    try {
      window.sessionStorage.removeItem(trafficStorageKey);
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browsers.
    }
  }

  function refreshAnalyticsPermission() {
    try {
      analyticsProcessingAllowed = !!(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
      marketingProcessingAllowed = !!(
        window.Shopify.customerPrivacy.marketingAllowed &&
        window.Shopify.customerPrivacy.saleOfDataAllowed &&
        window.Shopify.customerPrivacy.marketingAllowed() &&
        window.Shopify.customerPrivacy.saleOfDataAllowed()
      );
      if (analyticsProcessingAllowed && marketingProcessingAllowed) {
        trafficSource();
      } else {
        clearTrafficSource();
      }
    } catch (error) {
      analyticsProcessingAllowed = false;
      marketingProcessingAllowed = false;
      clearTrafficSource();
    }
  }

  function initAnalyticsPermission() {
    document.addEventListener('visitorConsentCollected', refreshAnalyticsPermission);
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      clearTrafficSource();
      return;
    }

    try {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) {
            analyticsProcessingAllowed = false;
            marketingProcessingAllowed = false;
            clearTrafficSource();
            return;
          }
          refreshAnalyticsPermission();
        }
      );
    } catch (error) {
      analyticsProcessingAllowed = false;
      marketingProcessingAllowed = false;
      clearTrafficSource();
    }
  }

  function classifyReferrer(referrer) {
    if (!referrer) return 'other';

    var hostname;
    try {
      hostname = new URL(referrer).hostname.toLowerCase();
    } catch (error) {
      return 'other';
    }

    if (hostname === 'google.com' || hostname.endsWith('.google.com')) return 'google';
    if (hostname === 'bing.com' || hostname.endsWith('.bing.com')) return 'bing';
    if (hostname === 'search.yahoo.com' || hostname.endsWith('.search.yahoo.com')) return 'yahoo';
    if (hostname === 'duckduckgo.com' || hostname.endsWith('.duckduckgo.com')) return 'duckduckgo';
    return 'other';
  }

  function trafficSource() {
    var stored = null;
    try {
      stored = window.sessionStorage && window.sessionStorage.getItem(trafficStorageKey);
    } catch (error) {
      stored = null;
    }
    if (organicSources.indexOf(stored) !== -1) return stored;

    var source = classifyReferrer(document.referrer);
    if (organicSources.indexOf(source) === -1) return 'other';

    try {
      if (window.sessionStorage) window.sessionStorage.setItem(trafficStorageKey, source);
    } catch (error) {
      // Attribution remains usable for this click without persistent browser state.
    }
    return source;
  }

  function sourcePage() {
    var pageType = document.body && document.body.dataset ? document.body.dataset.cmhPageType : '';
    if (pageType === 'article') return 'article';
    if (pageType === 'blog') return 'journal';
    return 'storefront';
  }

  function linkPosition(link) {
    var supplied = link.dataset && link.dataset.cmhLinkPosition;
    if (allowedLinkPositions.indexOf(supplied) !== -1) return supplied;
    if (typeof link.closest === 'function' && link.closest('.cmh-article-content')) return 'article_body';
    return 'unknown';
  }

  function publishAssessmentRouteClick(link, source) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;

    var position = linkPosition(link);
    try {
      window.Shopify.analytics.publish('assessment_route_click', {
        source_page: sourcePage(),
        traffic_source: source,
        link_position: position
      });
    } catch (error) {
      // Measurement must never block the assessment route.
    }
  }

  function initAssessmentTracking() {
    document.addEventListener('click', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var link = event.target.closest('a[href]');
      if (!link) return;

      var destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      var path = destination.pathname.replace(/\/+$/, '') || '/';
      if (destination.origin !== 'https://intake.concordiamenshealth.com' || path !== '/intake/weight-loss') return;

      if (analyticsProcessingAllowed && marketingProcessingAllowed && typeof window.fbq === 'function') {
        try {
          window.fbq('trackCustom', 'Start Assessment');
        } catch (error) {
          // A third-party pixel failure must not block safe assessment routing.
        }
      }
      if (!analyticsProcessingAllowed || !marketingProcessingAllowed) return;

      var source = trafficSource();
      if (organicSources.indexOf(source) !== -1) {
        destination.search = '';
        destination.hash = '';
        destination.searchParams.set('utm_source', source);
        destination.searchParams.set('utm_medium', 'organic');
        destination.searchParams.set('utm_campaign', 'seo');
        destination.searchParams.set('utm_content', sourcePage());
        link.href = destination.toString();
      }
      publishAssessmentRouteClick(link, source);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var nav = document.querySelector('[data-cmh-nav]');
    if (nav) initNav(nav);
    initReveal();
    initAnalyticsPermission();
    initAssessmentTracking();
  });
})();
